import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { VersionPath } from 'app/core/common';
import { BookingDetails } from 'app/views/booking-detail/models/booking-details.model';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { PathBookingManager } from './models/path-booking-list';

@Injectable({
  providedIn: 'root'
})
export class BookingManagerResourceService {
  private readonly httpClient = inject(HttpClient);

  public retrieveBooking(recordLocator: string): Observable<BookingDetails> {
    const url = `${environment.btbBFF.pbm.baseUrl}/${environment.btbBFF.pbm.nameApi}/${VersionPath.Version1}/${PathBookingManager.Booking}/${PathBookingManager.GetDetails}`;
    return this.httpClient.post<BookingDetails>(url, { recordLocator });
  }
}
